import { render, staticRenderFns } from "./CalculatorPersonalGainPartner.vue?vue&type=template&id=1bf1422a"
import script from "./CalculatorPersonalGainPartner.vue?vue&type=script&lang=js"
export * from "./CalculatorPersonalGainPartner.vue?vue&type=script&lang=js"
import style0 from "./CalculatorPersonalGainPartner.vue?vue&type=style&index=0&id=1bf1422a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports